export function reorder(list, startIndex, endIndex){
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
}

export function getListStyle(isDraggingOver){
    return {
        background: isDraggingOver ? '#F4FBFF' : `transparent`,

        width: 'auto',
    };
}

export function getItemStyle(isDragging, draggableStyle){
   
    if( isDragging){
        return Object.assign({}, draggableStyle, {
            userSelect: 'none',
            margin: 0,
            position: `absolute`,
            right: 0,
            left: `auto`,
            top: 0,
            opacity: 0.7,
        });
    }else{
        return Object.assign({}, draggableStyle, {
            userSelect: 'none',
            margin: 0,
            left: `auto`,

            /*padding: 0,
            margin: '10px 0',*/
        });
    }


}



/** WEBPACK FOOTER **
 ** ./src/helpers/dndHelper.js
 **/